var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-5"},[_c('action-buttons'),_c('div',{staticClass:"border-round",staticStyle:{"background":"#ffff","overflow":"hidden"}},[_c('order-details',{attrs:{"orderId":_vm.orderId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }